<template>
    <form-row title="Were Lawyers Sent Closing Info?">
        <div class="flex items-center">
            <div class="flex items-center mt-4 mb-3">
                <input-radio-boolean
                    class="ml-0"
                    name="seller_lawyers_sent_closing_info"
                    v-model="seller_lawyers_sent_closing_info"
                    true="Yes"
                    false="No"
                    :read_only="read_only"
                />
            </div>

            <div v-if="seller_lawyers_sent_closing_info"
                class="flex-1 -mt-4 ml-6"
            >
                <input-date
                    name="seller_lawyers_sent_closing_info_date"
                    :value="deal.seller_lawyers_sent_closing_info_date"
                    label="Sent at"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
export default {
    props: {
        deal: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            seller_lawyers_sent_closing_info: this.deal.seller_lawyers_sent_closing_info,
        }
    },
}
</script>
